import axiosInstance from "./axios";
import { safeLogger } from "../utils/logger";
import { PackageDto } from '../types/package.types';


// הממשק כפי שהוא מגיע מהשרת
interface ServerAnalystDto {
  code: number;
  email: string;
  fname: string;
  lname: string;
  id: string;
}

// הממשק כפי שאנחנו רוצים להשתמש בו בקליינט
export interface AnalystDto {
  code: number;
  firstName: string;
  lastName: string;
  idNumber: string;
  email: string;
}

// פונקציית עזר להמרה מפורמט השרת לפורמט הקליינט
const mapServerToClient = (analyst: ServerAnalystDto): AnalystDto => ({
  code: analyst.code,
  firstName: analyst.fname,
  lastName: analyst.lname,
  idNumber: analyst.id,
  email: analyst.email,
});

// פונקציית עזר להמרה מפורמט הקליינט לפורמט השרת
const mapClientToServer = (analyst: Partial<AnalystDto>): Partial<ServerAnalystDto> => ({
  ...(analyst.code !== undefined && { code: analyst.code }),
  ...(analyst.firstName !== undefined && { fname: analyst.firstName }),
  ...(analyst.lastName !== undefined && { lname: analyst.lastName }),
  ...(analyst.idNumber !== undefined && { id: analyst.idNumber }),
  ...(analyst.email !== undefined && { email: analyst.email }),
});

export const AnalystService = {
  getAll: async (): Promise<AnalystDto[]> => {
    const res = await axiosInstance.get<ServerAnalystDto[]>("analyst");
    safeLogger.log('Analysts data received from server');
    return res.data.map(mapServerToClient);
  },

  getById: async (id: number): Promise<AnalystDto> => {
    const res = await axiosInstance.get<ServerAnalystDto>(`analyst/${id}`);
    return mapServerToClient(res.data);
  },

  add: async (analyst: Omit<AnalystDto, "code">): Promise<AnalystDto> => {
    const serverAnalyst = mapClientToServer(analyst);
    const res = await axiosInstance.post<ServerAnalystDto>("analyst", serverAnalyst);
    return mapServerToClient(res.data);
  },

  update: async (id: number, analyst: AnalystDto): Promise<void> => {
    const serverAnalyst = mapClientToServer(analyst);
    console.log(`[DEBUG-ANALYST] Updating analyst ${id}:`, { original: analyst, mapped: serverAnalyst });
    try {
      await axiosInstance.put(`analyst/${id}`, serverAnalyst);
      console.log(`[DEBUG-ANALYST] Update success for analyst ${id}`);
    } catch (error) {
      console.error(`[DEBUG-ANALYST] Update failed for analyst ${id}:`, error);
      throw error;
    }
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`analyst/${id}`);
  },
};

export const getCurrentAnalystPackage = async (): Promise<PackageDto> => {
  const res = await axiosInstance.get("analyst/analysts-package");
  return res.data;
};
